import feathers from '../../feathers'

export default {
  namespaced: true,
  state: {
    fetched: false,
    aircrafts: [],
    selectedAircraft: undefined
  },
  getters: {
    listAricrafts: (state) => state.aircrafts,
    currentAircraft: (state) => state.selectedAircraft ? state.aircrafts.find(aircraft => aircraft._id === state.selectedAircraft) : {}
  },
  actions: {
    async find ({ state, commit }) {
      if (!state.fetched) {
        const aircrafts = await feathers.client.service('api/my-plane/aircrafts').find()
        commit('setAircrafts', aircrafts)
      }
    },
    setCurrentAircraft ({ commit }, aircraftId) {
      commit('setCurrentAircraft', aircraftId)
    }
  },
  mutations: {
    setCurrentAircraft (state, aircraftId) {
      state.selectedAircraft = aircraftId
    },
    setAircrafts (state, aircrafts) {
      state.fetched = true
      state.aircrafts = aircrafts
      if (!state.selectedAircraft && aircrafts.length) {
        state.selectedAircraft = aircrafts[0]._id
      }
    }
  }
}
